const packageJson = require('../../package.json');

const config = {
    version: packageJson.version,
    debugMode: true,
};

export default config;